<template>
  <div id="autocomplete">
    <div
      class="form-group"
      :description="`Type in the value of ${placeholder}`"
    >
      <label v-if="label !== ''" :for="name"> {{ label }} </label>
      <v-select
        multiple
        style="line-height: 20px"
        v-model="selectedValues"
        :reduce="(option) => option.value"
        label="text"
        :id="`${name}-${index || ''}`"
        :type="type"
        :options="options"
        :name="name"
        :size="size"
        :disabled="evalLogic(name, 'disable') || isDisabled"
        :state="$hasField(name, errors)"
        @input="setValue"
      />
      <small class="text-muted"> Type in the value of {{ placeholder }} </small>
      <!-- display error messages -->
      <error-message
        v-if="!$hasField({ name, errors, index }) && showError"
        :errors="errors"
        :fieldName="name"
      />
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: Array,
      default: () => [],
    },
    parent: {
      type: String,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "sm",
    },
    isDisabled: {
      type: Boolean,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: [Object, Array],
    },
    logic: {
      type: Object,
    },
    options: {
      type: Array,
      required: true,
    },
    content: {
      type: Object,
    },
  },
  data: () => ({
    selectedValues: [],
  }),
  watch: {
    selectedValues: {
      handler(val) {
        this.setValue(val);
      },
    },
  },
  mounted() {
    this.selectedValues = [...this.value];
  },
  methods: {
    $hasField,
    handleFieldState,
    evalLogic(fieldName, stateType) {
      return this.handleFieldState({
        field: fieldName,
        stateType,
        logic: this.logic,
      });
    },
    setValue(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style></style>
